import CoachesPage from "../components/CoachesPage";

function About() {
  return (
    <CoachesPage />
  );
}

export default About;